import { graphql } from "../../graphql"

export const query = graphql(`
  query JourneyNavigationMobile($journeyId: ID!) {
    productCategory(id: $journeyId) {
      id
      title
      backgroundImageUrl
      teaserImageUrl
      isLocked
      progress: journeyProgress {
        certified
      }
      journeyFolder {
        id
        title
        journeys(limit: 1000, page: 1) {
          nodes {
            id
            isLocked
            progress: journeyProgress {
              certified
            }
          }
        }
      }
    }
    productCategories(isJourney: true, limit: 1, page: 1) {
      pageInfo {
        totalItemCount
      }
    }
  }
`)

type JourneyFolder = {
  id: string
  title: string | null
  journeys: {
    nodes: { id: string; isLocked: boolean; progress: { certified: boolean } }[]
  }
}

export type Journey = {
  id: string
  title: string | null
  backgroundImageUrl: string | null
  teaserImageUrl: string | null
  isLocked: boolean
  progress: {
    certified: boolean
  }
  journeyFolder: JourneyFolder | null
}
